module.exports = __webpack_public_path__ + "img/white-and-grey-box-3248556.0722a23c.jpg";